import type { PopTechSpecsFeatureData } from '@/app/[locale]/product/rings/_types';

import PopTechSpecsFeature from './PopTechSpecsFeature';

export interface PopTechSpecsFeaturesProps {
  readonly features: PopTechSpecsFeatureData[];
}

const PopTechSpecsFeatures = ({
  features,
}: PopTechSpecsFeaturesProps): JSX.Element => {
  return (
    <ul className="flex flex-wrap justify-between gap-y-9 md:gap-y-12 xl:gap-y-32">
      {features.map(({ id, ...feature }) => (
        <li key={id} className="w-full flex-initial md:w-[45%] xl:w-[27.5%]">
          <PopTechSpecsFeature {...feature} />
        </li>
      ))}
    </ul>
  );
};

export default PopTechSpecsFeatures;
